import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import Target from './primitives/Target'
import Skills from './primitives/Skills'
import Person from './primitives/Person'

import {
  SlideWrapper,
  TitleText,
  ProfileSection,
  TargetsSection,
  DesiredSkillsSection,
  SlideBody,
} from './HowItWorksSlide.styles'

const HowItWorksSlide = ({
  title,
  profile,
  targetsSection,
  recruitingOpps,
  desiredSkills,
  skillsIcon,
  body,
  leftAlign,
  mobilePad,
}) => {
  return (
    <SlideWrapper>
      <TitleText>
        <p>{title}</p>
      </TitleText>
      <ProfileSection leftAlign={leftAlign} mobilePad={mobilePad}>
        <GatsbyImage image={profile.gatsbyImageData} alt="" />
        {profile.name && (
          <div className="profile-text">
            {profile.name && <p className="profile-name">{profile.name}</p>}
            {profile.industry && <p>{profile.industry}</p>}
            {profile.uni && <p>{profile.uni}</p>}
          </div>
        )}
        {profile.paras && (
          <div className="paras">
            {profile.paras.map((para, i) => (
              <React.Fragment key={`para-${i}`}>{para}</React.Fragment>
            ))}
          </div>
        )}
      </ProfileSection>
      {body && (
        <SlideBody>
          <p className="body-head">{body.head}</p>
          <p className="body-para">{body.para}</p>
        </SlideBody>
      )}
      {targetsSection && (
        <TargetsSection>
          <div className="icon-header">
            {targetsSection.customIcon ? targetsSection.customIcon : <Target />}
            {targetsSection.heading}
          </div>
          {targetsSection.paras &&
            targetsSection.paras.map((para, i) => (
              <React.Fragment key={`target-${i}`}>{para}</React.Fragment>
            ))}
        </TargetsSection>
      )}
      {recruitingOpps && (
        <TargetsSection>
          <div style={{ marginTop: '37px' }} />
          <div className="icon-header">
            <Person />
            {recruitingOpps.heading
              ? recruitingOpps.heading
              : 'Recruiting Opportunities'}
          </div>
          {recruitingOpps.paras &&
            recruitingOpps.paras.map((para, i) => (
              <React.Fragment key={`target-${i}`}>{para}</React.Fragment>
            ))}
        </TargetsSection>
      )}
      {desiredSkills && (
        <DesiredSkillsSection singleRow={desiredSkills.singleRow || false}>
          <div className="icon-header">
            {desiredSkills.header ? (
              skillsIcon ? (
                <>
                  <Skills />
                  {desiredSkills.header}
                </>
              ) : (
                desiredSkills.header
              )
            ) : (
              <>
                <Skills /> Desired Skills
              </>
            )}
          </div>
          <ul>
            {desiredSkills.content.map((item, i) => (
              <li key={`HIW-list-item-${Math.random()}`}>
                {item.icon}
                {item.skill}
              </li>
            ))}
          </ul>
        </DesiredSkillsSection>
      )}
    </SlideWrapper>
  )
}

export default HowItWorksSlide
